var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notion__Property 1=Notion",
    className: "notion__Property notion__1=Notion",
    clipPath: "url(#notion__clip0_16058_193803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "notion__Vector",
    fill: "#000",
    d: "M4.776 4.967c.711.58.98.54 2.324.45l12.664-.76c.27 0 .045-.27-.045-.315l-2.104-1.52c-.4-.315-.94-.67-1.97-.584l-12.258.898c-.45.04-.54.266-.36.446l1.749 1.385Zm.76 2.954v13.322c0 .715.355.985 1.16.94l13.918-.805c.805-.046.898-.536.898-1.12V7.027c0-.584-.224-.894-.718-.85l-14.543.85c-.539.046-.715.31-.715.892v.003Zm13.738.71c.09.406 0 .806-.405.855l-.67.135v9.833c-.584.315-1.119.495-1.564.495-.72 0-.899-.225-1.434-.895l-4.387-6.887v6.663l1.388.315s0 .805-1.119.805l-3.088.18c-.09-.18 0-.63.315-.716l.805-.225v-8.808l-1.12-.09c-.09-.404.136-.984.76-1.029l3.313-.225 4.567 6.978V9.842l-1.165-.136c-.09-.49.266-.85.715-.89l3.089-.184ZM2.357 1.929l12.754-.94c1.565-.135 1.97-.045 2.953.67l4.073 2.864c.67.49.895.625.895 1.16v15.696c0 .985-.36 1.565-1.61 1.655l-14.816.895c-.936.045-1.385-.09-1.88-.716L1.728 19.32c-.536-.715-.76-1.25-.76-1.875V3.494c0-.806.36-1.476 1.389-1.565v-.001Z",
    className: "notion__Vector"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "notion__clip0_16058_193803",
    className: "notion__clip0_16058"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .436h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotion);
export default __webpack_public_path__ + "static/media/Notion.6af27a0b9404a25ac49312bc411df88f.svg";
export { ForwardRef as ReactComponent };